<!-- 
Wrapper for a button that also offers tooltips, icons and a progress indicator.
-->
<template>
  <span>
    <v-tooltip 
      v-if="tooltip" 
      top open-delay="0" close-delay="0" transition="null"
    >
      <v-btn 
        slot="activator" 
        :disabled="saving || disabled" 
        :flat="flat" 
        :small="small" 
        :color="color" 
        :class="margins" 
        @click="click"
      >
        <v-progress-circular 
          v-if="showProgress" 
          size="24" class="mr-2" indeterminate color="default"
        />
        <v-icon v-if="!showProgress" :color="color" class="mr-2">{{ icon }}</v-icon>
        <slot/>
      </v-btn>
      <span>{{ tooltip }}</span>
    </v-tooltip>
    <v-btn 
      v-else
      :disabled="saving || disabled" 
      :flat="flat" 
      :small="small" 
      :color="color" 
      :class="margins" 
      @click="click"
    >
      <v-progress-circular 
        v-if="showProgress" 
        size="24" class="mr-2" indeterminate color="default"
      />
      <v-icon v-if="!showProgress" :color="color" class="mr-2">{{ icon }}</v-icon>
      <slot/>
    </v-btn>
  </span>
</template>

<script>
export default {
  name: "OurActionButton",
  props: {
    icon: {
      type: String,
      required: true
    },
    saving: {
      type: Boolean,
      default: false
    },
    flat: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ""
    },
    progressIndicator: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    margins: {
      type: String,
      default: "ml-0 mr-3 mb-3"
    }
  },
  data() {
    return {
      clicked: false
    };
  },
  computed: {
    showProgress() {
      return this.progressIndicator && this.saving && this.clicked;
    }
  },
  watch: {
    saving(nowSaving) {
      if (!nowSaving) {
        this.clicked = false;
      }
    }
  },
  methods: {
    click() {
      this.clicked = true;
      this.$emit("click");
    }
  }
};
</script>
